import styled from "styled-components";

export const CounterContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 6px;
    justify-content: center;
    width: 100%;
`
export const BtnsContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
`
export const BtnContainer = styled.div`
    height: 30px;
    width: 30px;
`
export const DisplayContainer = styled.div`
    height: 50px;
    width: 50px;
`
export const CounterLabel = styled.h4`
    font-size: 16px;
`